// extracted by mini-css-extract-plugin
export default {"reset":"ResetButton_reset__dNP+d"};